import { Constants } from '../constants'
const qs = require('qs')

export function loginRequest(formData) {
    return (dispatch, getState) => {
        return dispatch(login(formData))
    }
}

export function getNewAccessToken(authToken, formData) {
    return (dispatch, getState) => {
        return dispatch(newAccessToken(authToken, formData))
    }
}

export function depositRequest(authToken, formData) {
    return (dispatch, getState) => {
        return dispatch(depositCrypto(authToken, formData))
    }
}

export function loadSupportdCoinRequest(authToken) {
    return (dispatch, getState) => {
        return dispatch(loadSupportdCoin(authToken))
    }
}

export function depositStatusRequest(authToken, formData) {
    return (dispatch, getState) => {
        return dispatch(depositStatus(authToken, formData))
    }
}
export function profileUpdateRequest(authToken, formData) {
    return (dispatch, getState) => {
        return dispatch(profileUpdate(authToken, formData))
    }
}

export function paymentWithdrawRequest(authToken, formData) {
    return (dispatch, getState) => {
        return dispatch(paymentWithdraw(authToken, formData))
    }
}

export function changePasswordRequest(authToken, formData) {
    return (dispatch, getState) => {
        return dispatch(changePassword(authToken, formData))
    }
}

export function getAllCreatorsRequest(page) {
    return (dispatch, getState) => {
        return dispatch(getAllCreators(page))
    }
}

export function getUserDataRequest(handle) {
    return (dispatch, getState) => {
        return dispatch(getUserData(handle))
    }
}

export function userSignupRequest(formData) {
    return (dispatch, getState) => {
        return dispatch(userSignup(formData))
    }
}

export function allTransactionRequest(authToken) {
    return (dispatch, getState) => {
        return dispatch(allTransaction(authToken))
    }
}

export function userForgotPasswordRequest(formData) {
    return (dispatch, getState) => {
        return dispatch(userForgotPassword(formData))
    }
}
export function userAccessHistoryRequest(authToken) {
    return (dispatch, getState) => {
        return dispatch(userAccessHistory(authToken))
    }
}

export function emailSubscriptionRequest(authToken, formData) {
    return (dispatch, getState) => {
        return dispatch(emailSubscription(authToken, formData))
    }
}

export function resetPassEmailRequest(formData) {
    return (dispatch, getState) => {
        return dispatch(resetPassEmail(formData))
    }
}

export function userDeactivateRequest(authToken) {
    return (dispatch, getState) => {
        return dispatch(userDeactivate(authToken))
    }
}

export function userLogout() {
    return (dispatch, getState) => {
        return dispatch({
            type: Constants.LOGOUT
        })
    }
}

export const createAkoladeRequest = (authToken, formData) => {
    return (dispatch, getState) => {
        return dispatch(createAkolade(authToken, formData))
    }
}

export const revokeRefreshTokenRequest = (authToken, formData) => {
    return (dispatch, getState) => {
        return dispatch(revokeRefreshToken(authToken, formData))
    }
}

export const searchRequest = (keyword, category, page) => {
    return (dispatch, getState) => {
        return dispatch(search(keyword, category, page))
    }
}

export function contactUsRequest(formData) {
    return (dispatch, getState) => {
        return dispatch(contactUs(formData))
    }
}

export const getSocialDataRequest = (url, authToken) => {
    return (dispatch, getState) => {
        return dispatch(getSocialData(url, authToken))
    }
}

export const getUserBalanceRequest = authToken => {
    return (dispatch, getState) => {
        return dispatch(getUserBalance(authToken))
    }
}

export const getUsersReferralsRequest = authToken => {
    return (dispatch, getState) => {
        return dispatch(getUsersReferrals(authToken))
    }
}

export const sendFlashMessage = (message, className) => {
    return {
        type: Constants.FLASH_MESSAGE,
        payload: {
            message,
            className
        }
    }
}

export const reportFakeRequest = (authToken, formData) => {
    return (dispatch, getState) => {
        return dispatch(reportFake(authToken, formData))
    }
}

export function cancelAkoladeRequest(authToken, formData) {
    return (dispatch, getState) => {
        return dispatch(cancelAkolade(authToken, formData))
    }
}

export const getgetAkoladeSendRequest = authToken => {
    return (dispatch, getState) => {
        return dispatch(getAkoladeSend(authToken))
    }
}

export const getTokenHistoryRequest = authToken => {
    return (dispatch, getState) => {
        return dispatch(getTokenHistory(authToken))
    }
}

export const clearFlashMessage = () => {
    return {
        type: Constants.FLASH_MESSAGE_CLEAR
    }
}

export function loginRedirect(url) {
    return (dispatch, getState) => {
        return dispatch({
            type: 'LOGIN_REDIRECT',
            payload: url
        })
    }
}

export const createAppRequest = (authToken, formData) => {
    return (dispatch, getState) => {
        return dispatch(createApp(authToken, formData))
    }
}

export const getAppListRequest = authToken => {
    return (dispatch, getState) => {
        return dispatch(getAppList(authToken))
    }
}
export const confirmAppTxnRequest = (authToken, uId) => {
    return (dispatch, getState) => {
        return dispatch(confirmAppTxn(authToken, uId))
    }
}
export const akoladeViaAppRequest = (authToken, formData) => {
    return (dispatch, getState) => {
        return dispatch(akoladeViaApp(authToken, formData))
    }
}
export const deactivateAppRequest = (authToken, formData) => {
    return (dispatch, getState) => {
        return dispatch(deactivateApp(authToken, formData))
    }
}

function login(formData) {
    return {
        type: 'LOGIN_REQUEST',
        payload: {
            request: {
                url: '/user/login',
                method: 'POST',
                headers: {
                    'Content-type': 'application/x-www-form-urlencoded'
                },
                data: qs.stringify(formData)
            },
            options: {
                onSuccess({ getState, dispatch, response }) {
                    response.data.authorization = response.headers.authorization
                    response.data.refreshtoken = response.headers.refreshtoken
                    dispatch([
                        {
                            type: Constants.LOGIN_REQUEST_SUCCESS,
                            payload: response.data
                        },
                        loadUserRequest(response.data.authorization)
                    ])
                },
                onError({ getState, dispatch, error }) {
                    dispatch({
                        type: Constants.LOGIN_REQUEST_FAILURE,
                        payload: error.response.data
                    })
                }
            }
        }
    }
}

function loadUserRequest(authToken) {
    return {
        type: 'USER_GET',
        payload: {
            request: {
                url: '/user?timeStamp' + new Date().valueOf(),
                headers: {
                    Authorization: authToken
                }
            },
            options: {
                onSuccess({ getState, dispatch, response }) {
                    dispatch({
                        type: Constants.USER_GET_SUCCESS,
                        payload: response.data
                    })
                },
                onError({ getState, dispatch, error }) {
                    dispatch({
                        type: Constants.USER_GET_FAILURE,
                        payload: error.response.data
                    })
                }
            }
        }
    }
}

function depositCrypto(authToken, formData) {
    return {
        type: 'DEPOSIT_CRYPTO',
        method: 'POST',
        payload: {
            request: {
                url: '/payment/deposit',
                method: 'POST',
                headers: {
                    'Content-type': 'application/x-www-form-urlencoded',
                    Authorization: authToken
                },
                data: qs.stringify(formData)
            },
            options: {
                onSuccess({ getState, dispatch, response }) {
                    dispatch({
                        type: Constants.DEPOST_POST_SUCCESS,
                        payload: response.data
                    })
                },
                onError({ getState, dispatch, error }) {
                    dispatch({
                        type: Constants.DEPOST_POST_FAILURE,
                        payload: error.response.data
                    })
                }
            }
        }
    }
}

function depositStatus(authToken, formData) {
    return {
        type: 'DEPOSIT_STATUS',
        method: 'POST',
        payload: {
            request: {
                url: '/payment/status',
                method: 'POST',
                headers: {
                    'Content-type': 'application/x-www-form-urlencoded',
                    Authorization: authToken
                },
                data: qs.stringify(formData)
            },
            options: {
                onSuccess({ getState, dispatch, response }) {
                    dispatch({
                        type: Constants.DEPOST_STATUS_SUCCESS,
                        payload: response.data
                    })
                },
                onError({ getState, dispatch, error }) {
                    dispatch({
                        type: Constants.DEPOST_STATUS_FAILURE,
                        payload: error.response.data
                    })
                }
            }
        }
    }
}

function loadSupportdCoin(authToken) {
    return {
        type: 'GET_SUPPORTED_COINS',
        payload: {
            request: {
                url: '/payment/coins',
                headers: {
                    Authorization: authToken
                }
            },
            options: {
                onSuccess({ getState, dispatch, response }) {
                    dispatch({
                        type: Constants.GET_SUPPORTED_COINS_SUCCESS,
                        payload: response.data
                    })
                },
                onError({ getState, dispatch, error }) {
                    dispatch({
                        type: Constants.GET_SUPPORTED_COINS_FAILURE,
                        payload: error.response.data
                    })
                }
            }
        }
    }
}

function profileUpdate(authToken, formData) {
    return {
        type: 'PROFILE_UPDATE',
        payload: {
            request: {
                url: '/user',
                method: 'PUT',
                headers: {
                    'Content-type': 'application/x-www-form-urlencoded',
                    Authorization: authToken
                },
                data: qs.stringify(formData)
            },
            options: {
                onSuccess({ getState, dispatch, response }) {
                    dispatch([
                        {
                            type: Constants.PROFILE_UPDATE_SUCCESS,
                            payload: {
                                message: response.data.message,
                                statusCode: 200
                            }
                        },
                        loadUserRequest(authToken)
                    ])
                },
                onError({ getState, dispatch, error }) {
                    dispatch({
                        type: Constants.PROFILE_UPDATE_FAILURE,
                        payload: error.response.data
                    })
                }
            }
        }
    }
}

function paymentWithdraw(authToken, formData) {
    return {
        type: 'PAYMENT_WITHDRAW',
        payload: {
            request: {
                url: '/payment/withdraw',
                method: 'POST',
                headers: {
                    'Content-type': 'application/x-www-form-urlencoded',
                    Authorization: authToken
                },
                data: qs.stringify(formData)
            },
            options: {
                onSuccess({ getState, dispatch, response }) {
                    dispatch([
                        {
                            type: Constants.PAYMENT_WITHDRAW_SUCCESS,
                            payload: response.data
                        },
                        loadUserRequest(authToken)
                    ])
                },
                onError({ getState, dispatch, error }) {
                    dispatch({
                        type: Constants.PAYMENT_WITHDRAW_FAILURE,
                        payload: error.response.data
                    })
                }
            }
        }
    }
}

function changePassword(authToken, formData) {
    return {
        type: 'CHANGEPASSWORD',
        payload: {
            request: {
                url: '/user/changepass',
                method: 'POST',
                headers: {
                    'Content-type': 'application/x-www-form-urlencoded',
                    Authorization: authToken
                },
                data: qs.stringify(formData)
            },
            options: {
                onSuccess({ getState, dispatch, response }) {
                    dispatch([
                        {
                            type: Constants.PASSWORD_CHANGE_SUCCESS,
                            payload: response.data
                        }
                    ])
                },
                onError({ getState, dispatch, error }) {
                    dispatch({
                        type: Constants.PASSWORD_CHANGE_FAILURE,
                        payload: error.response.data
                    })
                }
            }
        }
    }
}

function getAllCreators(page) {
    return {
        type: 'GET_ALL_CREATORS',
        payload: {
            request: {
                url: '/userlist/' + page + '?timeStamp' + new Date().valueOf()
            },
            options: {
                onSuccess({ getState, dispatch, response }) {
                    dispatch({
                        type: Constants.GET_ALL_CREATORS_SUCCESS,
                        payload: response.data
                    })
                },
                onError({ getState, dispatch, error }) {
                    dispatch({
                        type: Constants.GET_ALL_CREATORS_FAILURE,
                        payload: error.response.data
                    })
                }
            }
        }
    }
}

function search(keyword, category, page) {
    return {
        type: 'SEARCH_REQUEST',
        payload: {
            request: {
                url:
                    '/search/' +
                    keyword +
                    '/' +
                    category +
                    '/' +
                    page +
                    '?timeStamp' +
                    new Date().valueOf()
            },
            options: {
                onSuccess({ getState, dispatch, response }) {
                    const type =
                        page > 1
                            ? Constants.GET_ALL_CREATORS_LOADMORE_SUCCESS
                            : Constants.GET_ALL_CREATORS_SUCCESS
                    dispatch({
                        type: type,
                        payload: response.data
                    })
                },
                onError({ getState, dispatch, error }) {
                    dispatch({
                        type: Constants.GET_ALL_CREATORS_FAILURE,
                        payload: error.response.data
                    })
                }
            }
        }
    }
}

function getUserData(handle) {
    return {
        type: 'GET_USERDATA',
        payload: {
            request: {
                url: '/' + handle + '?timeStamp' + new Date().valueOf()
            },
            options: {
                onSuccess({ getState, dispatch, response }) {
                    response.data.data.user.akoladeFrom =
                        response.data.data.akoladeFrom
                    dispatch({
                        type: Constants.GET_USERDATA_SUCCESS,
                        payload: response.data
                    })
                },
                onError({ getState, dispatch, error }) {
                    dispatch({
                        type: Constants.GET_USERDATA_FAILURE,
                        payload: error.response.data
                    })
                }
            }
        }
    }
}

function userSignup(formData) {
    return {
        type: 'SIGNUP_REQUEST',
        payload: {
            request: {
                url: '/user',
                method: 'POST',
                headers: {
                    'Content-type': 'application/x-www-form-urlencoded'
                },
                data: qs.stringify(formData)
            },
            options: {
                onSuccess({ getState, dispatch, response }) {
                    dispatch([
                        {
                            type: Constants.SIGNUP_REQUEST_SUCCESS,
                            payload: response
                        }
                    ])
                },
                onError({ getState, dispatch, error }) {
                    dispatch({
                        type: Constants.SIGNUP_REQUEST_FAILURE,
                        payload: error.response
                    })
                }
            }
        }
    }
}

function allTransaction(authToken) {
    return {
        type: 'ALL_TRANSACTION',
        payload: {
            request: {
                url: '/payment/transactions?timeStamp' + new Date().valueOf(),
                headers: {
                    Authorization: authToken
                }
            },
            options: {
                onSuccess({ getState, dispatch, response }) {
                    dispatch({
                        type: Constants.ALL_TRANSACTION_SUCCESS,
                        payload: response.data
                    })
                },
                onError({ getState, dispatch, error }) {
                    dispatch({
                        type: Constants.ALL_TRANSACTION_FAILURE,
                        payload: error.response.data
                    })
                }
            }
        }
    }
}

function userForgotPassword(formData) {
    return {
        type: 'FORGOT_PASSWORD',
        payload: {
            request: {
                url: '/user/forgetpass',
                method: 'POST',
                headers: {
                    'Content-type': 'application/x-www-form-urlencoded'
                },
                data: qs.stringify(formData)
            },
            options: {
                onSuccess({ getState, dispatch, response }) {
                    dispatch([
                        {
                            type: Constants.FORGOT_PASSWORD_SUCCESS,
                            payload: response.data
                        }
                    ])
                },
                onError({ getState, dispatch, error }) {
                    dispatch({
                        type: Constants.FORGOT_PASSWORD_FAILURE,
                        payload: error.response.data
                    })
                }
            }
        }
    }
}

function userAccessHistory(authToken) {
    return {
        type: 'ACCESS_HISTORY',
        payload: {
            request: {
                url: '/user/activity?timeStamp' + new Date().valueOf(),
                headers: {
                    Authorization: authToken
                }
            },
            options: {
                onSuccess({ getState, dispatch, response }) {
                    dispatch({
                        type: Constants.ACCESS_HISTORY_SUCCESS,
                        payload: response.data
                    })
                },
                onError({ getState, dispatch, error }) {
                    dispatch({
                        type: Constants.ACCESS_HISTORY_FAILURE,
                        payload: error.response.data
                    })
                }
            }
        }
    }
}

const createAkolade = (authToken, formData) => {
    return {
        type: 'CREATE_AKOLADE',
        payload: {
            request: {
                url: '/akolade',
                method: 'POST',
                headers: {
                    'Content-type': 'application/x-www-form-urlencoded',
                    Authorization: authToken
                },
                data: qs.stringify(formData)
            },
            options: {
                onSuccess({ getState, dispatch, response }) {
                    dispatch({
                        type: Constants.CREATE_AKOLADE_SUCCESS,
                        payload: response.data
                    })
                },
                onError({ getState, dispatch, error }) {
                    dispatch({
                        type: Constants.CREATE_AKOLADE_FAILURE,
                        payload: error.response.data
                    })
                }
            }
        }
    }
}

const emailSubscription = (authToken, formData) => {
    return {
        type: 'EMAIL_SUBSCRIPTION',
        payload: {
            request: {
                url: '/emailsubs',
                method: 'POST',
                headers: {
                    'Content-type': 'application/x-www-form-urlencoded',
                    Authorization: authToken
                },
                data: qs.stringify(formData)
            },
            options: {
                onSuccess({ getState, dispatch, response }) {
                    dispatch([
                        {
                            type: Constants.EMAIL_SUBSCRIPTION_SUCCESS,
                            payload: response.data
                        },
                        loadUserRequest(authToken)
                    ])
                },
                onError({ getState, dispatch, error }) {
                    dispatch({
                        type: Constants.EMAIL_SUBSCRIPTION_FAILURE,
                        payload: error.response.data
                    })
                }
            }
        }
    }
}

const userDeactivate = authToken => {
    return {
        type: 'USERDEACTIVATE',
        payload: {
            request: {
                url: '/user/deactivate',
                method: 'POST',
                headers: {
                    'Content-type': 'application/x-www-form-urlencoded'
                }
            },
            options: {
                onSuccess({ getState, dispatch, response }) {
                    dispatch([
                        {
                            type: Constants.USERDEACTIVATE_SUCCESS,
                            payload: response.data
                        }
                    ])
                },
                onError({ getState, dispatch, error }) {
                    dispatch({
                        type: Constants.USERDEACTIVATE_FAILURE,
                        payload: error.response.data
                    })
                }
            }
        }
    }
}

const contactUs = formData => {
    return {
        type: 'CONTACTUS',
        payload: {
            request: {
                url: '/contactus',
                method: 'POST',
                headers: {
                    'Content-type': 'application/x-www-form-urlencoded'
                },
                data: qs.stringify(formData)
            },
            options: {
                onSuccess({ getState, dispatch, response }) {
                    dispatch([
                        {
                            type: Constants.CONTACTUS_SUCCESS,
                            payload: response.data
                        }
                    ])
                },
                onError({ getState, dispatch, error }) {
                    dispatch({
                        type: Constants.CONTACTUS_FAILURE,
                        payload: error.response.data
                    })
                }
            }
        }
    }
}

const getSocialData = (url, authToken) => {
    return {
        type: 'SOCIAL_MEDIA_DATA',
        payload: {
            request: {
                url: url
            },
            options: {
                onSuccess({ getState, dispatch, response }) {
                    dispatch(
                        profileUpdate(authToken, {
                            youtube_username: response.data.displayName.replace(
                                /\s/g,
                                ''
                            ),
                            youtube_id: response.data.id,
                            youtube_isverified: response.data.verified,
                            youtube_image: response.data.image.url
                        })
                    )
                },
                onError({ getState, dispatch, error }) {}
            }
        }
    }
}

const reportFake = (authToken, formData) => {
    return {
        type: 'REPORT_FAKE',
        payload: {
            request: {
                url: '/reportfake',
                method: 'POST',
                headers: {
                    'Content-type': 'application/x-www-form-urlencoded',
                    Authorization: authToken
                },
                data: qs.stringify(formData)
            },
            options: {
                onSuccess({ getState, dispatch, response }) {
                    dispatch([
                        {
                            type: Constants.REPORT_FAKE_SUCCESS,
                            payload: response.data
                        }
                    ])
                },
                onError({ getState, dispatch, error }) {
                    dispatch({
                        type: Constants.REPORT_FAKE_FAILURE,
                        payload: error.response.data
                    })
                }
            }
        }
    }
}

const getUserBalance = authToken => {
    return {
        type: 'GET_USER_BALANCE',
        payload: {
            request: {
                url: '/payment/balance?timeStamp' + new Date().valueOf(),
                headers: {
                    Authorization: authToken
                }
            },
            options: {
                onSuccess({ getState, dispatch, response }) {
                    dispatch([
                        {
                            type: Constants.GET_USER_BALANCE_SUCCESS,
                            payload: response.data
                        }
                    ])
                },
                onError({ getState, dispatch, error }) {
                    dispatch({
                        type: Constants.GET_USER_BALANCE_FAILURE,
                        payload: error.response.data
                    })
                }
            }
        }
    }
}

const resetPassEmail = formData => {
    return {
        type: 'RESET_PASS_EMAIL',
        payload: {
            request: {
                url: '/user/resetpass',
                method: 'POST',
                headers: {
                    'Content-type': 'application/x-www-form-urlencoded'
                },
                data: qs.stringify(formData)
            },
            options: {
                onSuccess({ getState, dispatch, response }) {
                    dispatch([
                        {
                            type: Constants.RESET_PASS_EMAIL_SUCCESS,
                            payload: response.data
                        }
                    ])
                },
                onError({ getState, dispatch, error }) {
                    dispatch({
                        type: Constants.RESET_PASS_EMAIL_FAILURE,
                        payload: error.response.data
                    })
                }
            }
        }
    }
}

const cancelAkolade = (authToken, formData) => {
    return {
        type: 'CANCEL_AKOLADE',
        payload: {
            request: {
                url: '/akolade',
                method: 'DELETE',
                headers: {
                    'Content-type': 'application/x-www-form-urlencoded',
                    Authorization: authToken
                },
                data: qs.stringify(formData)
            },
            options: {
                onSuccess({ getState, dispatch, response }) {
                    dispatch([
                        {
                            type: Constants.CANCEL_AKOLADE_SUCCESS,
                            payload: response.data
                        }
                    ])
                },
                onError({ getState, dispatch, error }) {
                    dispatch({
                        type: Constants.CANCEL_AKOLADE_FAILURE,
                        payload: error.response.data
                    })
                }
            }
        }
    }
}

const getAkoladeSend = authToken => {
    return {
        type: 'GET_AKOLADE_SEND',
        payload: {
            request: {
                url: '/akoladesend?' + new Date().valueOf(),
                headers: {
                    Authorization: authToken
                }
            },
            options: {
                onSuccess({ getState, dispatch, response }) {
                    dispatch([
                        {
                            type: Constants.GET_AKOLADE_SEND_SUCCESS,
                            payload: response.data
                        }
                    ])
                },
                onError({ getState, dispatch, error }) {
                    dispatch({
                        type: Constants.GET_AKOLADE_SEND_FAILURE,
                        payload: error.response.data
                    })
                }
            }
        }
    }
}

const newAccessToken = (authToken, formData) => {
    return {
        type: 'NEW_ACCESS_TOKEN',
        payload: {
            request: {
                url: '/newtoken',
                method: 'POST',
                headers: {
                    'Content-type': 'application/x-www-form-urlencoded'
                },
                data: qs.stringify(formData)
            },
            options: {
                onSuccess({ getState, dispatch, response }) {
                    response.data.authorization = response.headers.authorization
                    dispatch({
                        type: Constants.NEW_ACCESS_TOKEN_SUCCESS,
                        payload: response.data
                    })
                },
                onError({ getState, dispatch, error }) {
                    dispatch({
                        type: Constants.NEW_ACCESS_TOKEN_FAILURE,
                        payload: error.response.data
                    })
                }
            }
        }
    }
}

const getTokenHistory = authToken => {
    return {
        type: 'GET_TOKEN_HISTORY',
        payload: {
            request: {
                url: '/user/tokenhistory?' + new Date().valueOf(),
                headers: {
                    Authorization: authToken
                }
            },
            options: {
                onSuccess({ getState, dispatch, response }) {
                    dispatch([
                        {
                            type: Constants.GET_TOKEN_HISTORY_SUCCESS,
                            payload: response.data
                        }
                    ])
                },
                onError({ getState, dispatch, error }) {
                    dispatch({
                        type: Constants.GET_TOKEN_HISTORY_FAILURE,
                        payload: error.response.data
                    })
                }
            }
        }
    }
}

const revokeRefreshToken = (authToken, formData) => {
    return {
        type: 'REVOKE_REFRESH_TOKEN',
        payload: {
            request: {
                url: '/user/revoketoken',
                method: 'POST',
                headers: {
                    Authorization: authToken
                },
                data: qs.stringify(formData)
            },
            options: {
                onSuccess({ getState, dispatch, response }) {
                    dispatch({
                        type: Constants.REVOKE_REFRESH_TOKEN_SUCCESS,
                        payload: response.data
                    })
                },
                onError({ getState, dispatch, error }) {
                    dispatch({
                        type: Constants.REVOKE_REFRESH_TOKEN_FAILURE,
                        payload: error.response.data
                    })
                }
            }
        }
    }
}

const getUsersReferrals = authToken => {
    return {
        type: 'GET_USERS_REFERRALS',
        payload: {
            request: {
                url: '/user/refferals?' + new Date().valueOf(),
                headers: {
                    Authorization: authToken
                }
            },
            options: {
                onSuccess({ getState, dispatch, response }) {
                    dispatch([
                        {
                            type: Constants.GET_USERS_REFERRALS_SUCCESS,
                            payload: response.data
                        }
                    ])
                },
                onError({ getState, dispatch, error }) {
                    dispatch({
                        type: Constants.GET_USERS_REFERRALS_FAILURE,
                        payload: error.response.data
                    })
                }
            }
        }
    }
}

const createApp = (authToken, formData) => {
    return {
        type: 'CREATE_APP',
        payload: {
            request: {
                url: '/user/app/create',
                method: 'POST',
                headers: {
                    'Content-type': 'application/x-www-form-urlencoded',
                    Authorization: authToken
                },
                data: qs.stringify(formData)
            },
            options: {
                onSuccess({ getState, dispatch, response }) {
                    dispatch([
                        {
                            type: Constants.CREATE_APP_SUCCESS,
                            payload: response.data
                        },
                        getAppListRequest(authToken)
                    ])
                },
                onError({ getState, dispatch, error }) {
                    dispatch({
                        type: Constants.CREATE_APP_FAILURE,
                        payload: error.response.data
                    })
                }
            }
        }
    }
}
const getAppList = authToken => {
    return {
        type: 'GET_APP_LIST',
        payload: {
            request: {
                url: '/user/app/list?' + new Date().valueOf(),
                headers: {
                    Authorization: authToken
                }
            },
            options: {
                onSuccess({ getState, dispatch, response }) {
                    dispatch([
                        {
                            type: Constants.GET_APP_LIST_SUCCESS,
                            payload: response.data
                        }
                    ])
                },
                onError({ getState, dispatch, error }) {
                    dispatch({
                        type: Constants.GET_APP_LIST_FAILURE,
                        payload: error.response.data
                    })
                }
            }
        }
    }
}

function confirmAppTxn(authToken, uId) {
    return {
        type: 'CONFRIM_APP_TXN',
        payload: {
            request: {
                url: '/app/tx/' + uId + '?timeStamp' + new Date().valueOf(),
                headers: {
                    Authorization: authToken
                }
            },

            options: {
                onSuccess({ getState, dispatch, response }) {
                    return response.data
                },
                onError({ getState, dispatch, error }) {
                    return error.response.data
                }
            }
        }
    }
}

const akoladeViaApp = (authToken, formData) => {
    return {
        type: 'AKOLADE_VIA_APP',
        payload: {
            request: {
                url: '/app/akolade',
                method: 'POST',
                headers: {
                    'Content-type': 'application/x-www-form-urlencoded',
                    Authorization: authToken
                },
                data: qs.stringify(formData)
            },
            options: {
                onSuccess({ getState, dispatch, response }) {
                    return response.data
                    dispatch([
                        {
                            type: Constants.APP_PAYMENT_SUCCESS,
                            payload: response.data
                        }
                    ])
                },
                onError({ getState, dispatch, error }) {
                    return error.response.data
                    dispatch({
                        type: Constants.APP_PAYMENT_FAILURE,
                        payload: error.response.data
                    })
                }
            }
        }
    }
}
const deactivateApp = (authToken, formData) => {
    return {
        type: 'DEACTIVATE_APP',
        payload: {
            request: {
                url: '/user/app/deactivate',
                method: 'POST',
                headers: {
                    'Content-type': 'application/x-www-form-urlencoded',
                    Authorization: authToken
                },
                data: qs.stringify(formData)
            },
            options: {
                onSuccess({ getState, dispatch, response }) {
                    return response.data
                },
                onError({ getState, dispatch, error }) {
                    return error.response.data
                }
            }
        }
    }
}
